"use client";

import type { ReactNode } from "react";
import { Focusable } from "react-aria";
import { twMerge } from "tailwind-merge";
import { Tooltip } from "./Tooltip";

interface DisabledTooltipTriggerProps {
  reason: ReactNode;
  className: string;
  children: ReactNode;
  "aria-label"?: string | undefined;
  "aria-pressed"?: boolean | undefined;
  "aria-describedby"?: string | undefined;
}

export function DisabledTooltipTrigger({ reason, className, children, ...aria }: DisabledTooltipTriggerProps) {
  return (
    <Tooltip content={reason}>
      <Focusable>
        <span
          role="button"
          aria-disabled="true"
          onKeyDown={(event) => {
            if (event.key === " " || event.key === "Enter") event.preventDefault();
          }}
          className={twMerge(
            "cursor-not-allowed outline-none focus-visible:outline focus-visible:outline-2 focus-visible:outline-action-default",
            className
          )}
          {...aria}
        >
          {children}
        </span>
      </Focusable>
    </Tooltip>
  );
}
